import { SupportedChain } from '@boomeme/wallet-sdk';

export const CHAIN_LIST = [
  {
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    icon: '/icon/Chain-BSC.svg',
    symbol: 'BNB',
    label: 'BSC',
    path: 'bsc' as ChainType,
    chain: 'bsc' as SupportedChain,
    decimal: 6,
    chainId: 56,
  },
  {
    address: 'So11111111111111111111111111111111111111112',
    icon: '/icon/Chain-Sol.svg',
    symbol: 'SOL',
    label: 'SOLANA',
    path: 'sol' as ChainType,
    chain: 'solana' as SupportedChain,
    decimal: 9,
    chainId: 101,
  },
];

export const chainIdMapApiFix: { [key: string]: string } = {
  bsc: 'bsc',
  solana: 'sol',
};

export enum ChainType {
  SOL = 'sol',
  BSC = 'bsc',
}
